const styles = {
  image: {
    position: "relative",
    overflow: "hidden",
    width: (props) => props.width,
    height: (props) => props.height,
    cursor: "pointer",
  },
  iframe: {
    position: "absolute",
    pointerEvents: "none",
    top: (props) => props.top,
    left: (props) => props.left,
    height: (props) => props.iframeHeight,
    width: (props) => props.iframeWidth,
  },
  mediaIcon: {
    position: "absolute",
    bottom: "8px",
    right: "8px",
  },
};

export default styles;
